import axios from "axios";
import { getAccessToken, getCompanyId, getUserId } from "./utils.js";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
import { formatData } from "./insightsActionUtils.js";
import moment from "moment";

const platformId = "6ce32c0a-a789-11e4-a34f-74867a1157ba";
export const STORE_PAGE_TOKEN = "STORE_PAGE_TOKEN";
export const FETCH_IG_PAGE_LIST = "FETCH_IG_PAGE_LIST";
export const FETCH_IG_METRICS = "FETCH_IG_METRICS";
export const SET_SELECTED_PAGE = "SET_SELECTED_PAGE";
export const UPDATE_DURATION_FILTER = "UPDATE_DURATION_FILTER";
export const FETCH_PAGE_FOLLOWERS = "FETCH_PAGE_FOLLOWERS";

export function fetchInstagramPagesList() {
    let page_details = [];
    let res = axios({
        method: "get",
        url: getUrl("social_token_list"),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            response.data.data.tokens.map((k, v) => {
                if (k.platform === "instagram" && k.insight_feature === 1) {
                    page_details.push(k);
                }
            });
            return page_details;
        })
        .catch((err) => {
            toast.error(err?.response?.data?.message);
            return err;
        });
    return {
        type: "FETCH_IG_PAGE_LIST",
        payload: res,
    };
}

export function storeBusinessPages(param) {
    return function (dispatch) {
        axios({
            method: "post",
            url: getUrl("store_ig_insights_page"),
            data: param,
            headers: {
                "Content-Type": "application/json",
            },
            cache: false,
        })
            .then((res) => {
                toast.success("Your authorization was successful.");
                dispatch(fetchInstagramPagesList());
            })
            .catch((err) => {
                toast.error(err.response.data.message);
                return err;
            });
    };
}
export function getPageBusinessId(param) {
    return function (dispatch) {
        axios
            .get("https://graph.facebook.com/me/accounts?fields=name,instagram_business_account&access_token=" + param.accessToken)
            .then((res) => {
                let pageList = res.data.data;
                let buisness_accounts = [];
                if (pageList.length > 0) {
                    for (let i = 0; i < res.data.data.length; i++) {
                        if (res.data.data[i].instagram_business_account) {
                            buisness_accounts.push({
                                name: res.data.data[i].name,
                                id: res.data.data[i].instagram_business_account.id,
                            });
                        }
                    }
                    if (buisness_accounts.length == 0) {
                        toast.error("You do not have access to any valid Instagram Business Accounts.");
                        return;
                    } else {
                        let params = {};
                        params["fb_access_token"] = param.accessToken;
                        params["company_id"] = getCompanyId();
                        params["accounts"] = buisness_accounts;
                        params["platform_id"] = platformId;
                        params["app_name"] = "20twentyIGApp";
                        params["token_source"] = "20Twenty";
                        dispatch(storeBusinessPages(params));
                    }
                } else {
                    toast.error("You do not have access to any valid Instagram Business Accounts.");
                    return;
                }
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };
}
export function setSelectedPage(value) {
    return {
        type: "SET_SELECTED_PAGE",
        payload: value,
    };
}
export function updateDurationFilter(value) {
    return {
        type: "UPDATE_DURATION_FILTER",
        payload: value,
    };
}
export function fetchIgMetrics(params) {
    const chartName = params["name"];
    delete params["name"];

    return function (dispatch) {
        if (params?.isAverage) dispatch(fetchAverageIgMetrics(params, chartName));
        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });
        let resp = axios({
            method: "post",
            url: getUrl("ig_insights_metrics"),
            data: params,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: { chart_name: chartName, response: res.data.data },
                });
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
}

export function fetchAverageIgMetrics(chartParams, chartName) {
    const aggs_val = chartParams.agreegate_interval;

    let interval;
    if (aggs_val) {
        if (aggs_val === "yearly") interval = "year";
        else if (aggs_val === "monthly") interval = "month";
        else if (aggs_val === "weekly") interval = "week";
        else interval = "day";
    }

    return function (dispatch) {
        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });
        let resp = axios({
            method: "post",
            url: getUrl("ig_insights_metrics"),
            data: chartParams,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                const countData = res.data.data;

                let params = new URLSearchParams();

                params.append("start_date", chartParams.start_date);
                params.append("end_date", chartParams.end_date);
                params.append("data", "0");
                params.append("orderBy", "post.published_date");
                params.append("order", "desc");
                params.append("offset", "1");
                params.append("recordsPerPage", "50");
                params.append("post_type", "0");
                params.append("aggs-interval", interval);
                params.append("aggs", "conversation-over-time");
                params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
                params.append("custom_query", `handlers.value:"${chartParams.handler}"`);

                axios
                    .post(getUrl("searchaggs"), params, {
                        cache: false,
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                        },
                    })
                    .then((response) => {
                        dispatch({
                            type: "FETCH_IG_METRICS_FULFILLED",
                            payload: {
                                chart_name: chartName,
                                isAverage: chartParams.isAverage,
                                response: { postData: response.data?.aggregations?.conversation_over_time?.buckets, countData: countData.total },
                            },
                        });
                    })
                    .catch((err) => {
                        toast.error(err.response?.data.message);
                        dispatch({
                            type: "FETCH_IG_METRICS_REJECTED",
                            payload: { chart_name: chartName },
                        });
                    });
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
            });
    };
}

export const IgPostsOvertime = (data) => {
    return (dispatch) => {
        const chartName = data["name"];
        const aggs_val = data.agreegate_interval;

        let interval;
        if (aggs_val) {
            if (aggs_val === "yearly") interval = "year";
            else if (aggs_val === "monthly") interval = "month";
            else if (aggs_val === "weekly") interval = "week";
            else interval = "day";
        }

        let params = new URLSearchParams();

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", "0");
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("post_type", "0");
        params.append("exclude_post_subtypes", "story");
        params.append("aggs-interval", interval);
        params.append("aggs", "conversation-over-time");
        params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
        params.append("custom_query", `handlers.value:"${data.handler}"`);

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response.data,
                    },
                });
                return response.data;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const IgStoryOvertime = (data) => {
    return (dispatch) => {
        const chartName = data["name"];
        const aggs_val = data.agreegate_interval;

        let interval;
        if (aggs_val) {
            if (aggs_val === "yearly") interval = "year";
            else if (aggs_val === "monthly") interval = "month";
            else if (aggs_val === "weekly") interval = "week";
            else interval = "day";
        }

        let params = new URLSearchParams();

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", "0");
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("post_type", "0");
        params.append("post_subtype", "story");
        params.append("aggs-interval", interval);
        params.append("aggs", "conversation-over-time");
        params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
        params.append("custom_query", `handlers.value:"${data.handler}"`);

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response.data,
                    },
                });
                return response.data;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const IgStoryMediaBreakup = (data) => {
    return (dispatch) => {
        const chartName = data["name"];

        let params = new URLSearchParams();

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", 0);
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("post_type", "0");
        params.append("post_subtype", "story");
        params.append("aggs", "post-media-breakup");
        params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
        params.append("custom_query", `handlers.value:"${data.handler}"`);

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response.data,
                    },
                });
                return response.data;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const IgPageFollowersOvertimeData = (data) => {
    return (dispatch) => {
        const chartName = data["name"];
        const aggs_val = data.agreegate_interval;
        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        let interval;
        if (aggs_val) {
            if (aggs_val === "yearly") interval = "year";
            else if (aggs_val === "monthly") interval = "month";
            else if (aggs_val === "weekly") interval = "week";
            else interval = "day";
        }

        const users = [
            {
                username: data.handler,
                platform: "instagram",
            },
        ];
        const params1 = {
            start_date: data.start_date,
            end_date: data.end_date,
            interval,
            users,
            show_bucket: true,
        };

        //then((res) => ({ name: "followersOverTime", data: res.data?.results?.[0] }));

        axios({
            method: "post",
            url: getUrl("competitor_follower"),
            data: params1,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        // isAverage: data.isAverage,
                        response: response.data?.results?.[0],
                    },
                });
                return response;
            })
            .catch((err) => {
                toast.error(err.response?.data?.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const IgPostsEngagementRateOvertime = (data) => {
    return (dispatch) => {
        const chartName = data["name"];
        const aggs_val = data.agreegate_interval;

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });
        let interval;
        if (aggs_val) {
            if (aggs_val === "yearly") interval = "year";
            else if (aggs_val === "monthly") interval = "month";
            else if (aggs_val === "weekly") interval = "week";
            else interval = "day";
        }

        let params = new URLSearchParams();

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", "0");
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("post_type", "0");
        params.append("aggs-interval", interval);
        params.append("exclude_post_subtypes", "story");
        params.append("aggs", "likes_datewise_breakdown,comments_datewise_breakdown,shares_datewise_breakdown");
        params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
        params.append("custom_query", `handlers.value:"${data.handler}"`);

        const engagementData = axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((res) => ({ name: "engagementOverTime", data: res.data }));

        // const params1 = {
        //     account_id: data.account_id,
        //     agreegate_interval: aggs_val || "daily",
        //     start_date: data.start_date,
        //     end_date: data.end_date,
        //     filter_type: "insta_page_follower_change",
        //     handler: data.handler,
        // };
        const users = [
            {
                username: data.handler,
                platform: "instagram",
            },
        ];
        const params1 = {
            start_date: data.start_date,
            end_date: data.end_date,
            interval,
            users,
            show_bucket: true,
        };

        const followersOverTime = axios({
            method: "post",
            url: getUrl("competitor_follower"),
            data: params1,
            headers: {
                "Content-Type": "application/json",
            },
        }).then((res) => ({ name: "followersOverTime", data: res.data?.results?.[0] }));

        Promise.all([engagementData, followersOverTime])
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        // isAverage: data.isAverage,
                        response: response,
                    },
                });
                return response;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};
export const IgPostsEngagementOvertime = (data) => {
    return (dispatch) => {
        const chartName = data["name"];
        const aggs_val = data.agreegate_interval;

        let interval;
        if (aggs_val) {
            if (aggs_val === "yearly") interval = "year";
            else if (aggs_val === "monthly") interval = "month";
            else if (aggs_val === "weekly") interval = "week";
            else interval = "day";
        }

        let params = new URLSearchParams();

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", "0");
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("post_type", "0");
        params.append("aggs-interval", interval);
        params.append("exclude_post_subtypes", "story");
        params.append("aggs", "likes_datewise_breakdown,comments_datewise_breakdown,shares_datewise_breakdown");
        params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
        params.append("custom_query", `handlers.value:"${data.handler}"`);

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response.data,
                    },
                });
                return response.data;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

const getReachOverTime = (data) => {
    const aggs_val = data.agreegate_interval;

    let interval;
    if (aggs_val) {
        if (aggs_val === "yearly") interval = "year";
        else if (aggs_val === "monthly") interval = "month";
        else if (aggs_val === "weekly") interval = "week";
        else interval = "day";
    }

    let params = new URLSearchParams();

    params.append("start_date", data.start_date);
    params.append("end_date", data.end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("exclude_post_subtypes", "story");
    params.append("aggs-interval", interval);
    params.append("aggs", "reach_datewise_breakdown");
    params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${data.handler}"`);

    return axios.post(getUrl("searchaggs"), params, {
        cache: false,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
    });
};

const getEngagementOverTime = (data) => {
    let params = new URLSearchParams();

    params.append("start_date", data.start_date);
    params.append("end_date", data.end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("exclude_post_subtypes", "story");
    params.append("aggs-interval", "month");
    params.append("aggs", "likes_datewise_breakdown,comments_datewise_breakdown,shares_datewise_breakdown");
    params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${data.handler}"`);

    return axios.post(getUrl("searchaggs"), params, {
        cache: false,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
    });
};

export const IgPostsReachOvertime = (data) => {
    return (dispatch) => {
        const chartName = data["name"];

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        getReachOverTime(data)
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response.data,
                    },
                });
                return response.data;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const fetchTotalReach = (data) => {
    return (dispatch) => {
        const chartName = data["name"];

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        let reach1 = getReachOverTime(data).then((res) => ({ name: "reach1", data: res.data }));
        let data2 = { ...data };
        let durationGap = moment(data.end_date).diff(moment(data.start_date), "days", true);
        data2["start_date"] = moment(data.start_date)
            .subtract(durationGap + 1, "days")
            .startOf("day")
            .format("YYYY-MM-DD");
        data2["end_date"] = moment(data.start_date).subtract(1, "day").format("YYYY-MM-DD");

        let reach2 = getReachOverTime(data2).then((res) => ({ name: "reach2", data: res.data }));

        Promise.all([reach1, reach2])
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response,
                        durationGap,
                    },
                });
                return response.data;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const fetchTotalIgMetrics = (params) => {
    return axios({
        method: "post",
        url: getUrl("ig_insights_metrics"),
        data: params,
        headers: {
            "Content-Type": "application/json",
        },
    });
};

export const fetchPostsDetails = (data) => {
    let params = new URLSearchParams();
    params.append("start_date", data.start_date);
    params.append("end_date", data.end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    // if (data.name !== "total-stories" || data.name !== "total-stories-engagements") {
    //     console.log("falseee", data.name);
    //     params.append("exclude_post_subtypes", "story");
    // }
    if (data.name === "total-stories" || data.name === "total-stories-engagements") {
        params.append("post_subtype", "story");
    } else {
        params.append("exclude_post_subtypes", "story");
    }
    params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${data.handler}"`);

    switch (data.name) {
        case "total_engagement":
            params.append("aggs-interval", "year");
            params.append("aggs", "likes_datewise_breakdown,comments_datewise_breakdown,shares_datewise_breakdown");
            break;

        case "total_engagement_rate":
            params.append("aggs-interval", "year");
            params.append("aggs", "likes_datewise_breakdown,comments_datewise_breakdown,shares_datewise_breakdown");
            break;

        case "total-posts-likes":
            params.append("aggs-interval", "year");
            params.append("aggs", "likes_datewise_breakdown");
            break;

        case "total-posts-comments":
            params.append("aggs-interval", "year");
            params.append("aggs", "comments_datewise_breakdown");
            break;
        case "total-posts-impressions":
            params.append("aggs-interval", "year");
            params.append("aggs", "impressions_datewise_breakdown");
            break;
        // case "total-stories":
        //     // params.append("post_subtype", "story");
        //     break;
        case "total-stories-engagements":
            params.append("aggs-interval", "year");
            params.append(
                "aggs",
                "view_datewise_breakdown,exits_datewise_breakdown,comments_datewise_breakdown,taps_forwards_datewise_breakdown,taps_backwards_datewise_breakdown",
            );
            break;

        default:
            break;
    }

    return axios.post(getUrl("searchaggs"), params, {
        cache: false,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
    });
};

export const fetchDataFromInsta = (ApiCall, data) => {
    return (dispatch) => {
        const chartName = data["name"];

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        let presentDurationData = ApiCall(data).then((res) => ({ name: "presentDurationData", data: res.data }));
        let data2 = { ...data };
        let durationGap = moment(data.end_date).diff(moment(data.start_date), "days", true);
        data2["start_date"] = moment(data.start_date)
            .subtract(durationGap + 1, "days")
            .startOf("day")
            .format("YYYY-MM-DD");
        data2["end_date"] = moment(data.start_date).subtract(1, "day").format("YYYY-MM-DD");

        let previousDurationData = ApiCall(data2).then((res) => ({ name: "previousDurationData", data: res.data }));

        Promise.all([presentDurationData, previousDurationData])
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response,
                        durationGap,
                    },
                });
                return response;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const fetchTotalEngagement = (data) => {
    return (dispatch) => {
        const chartName = data["name"];

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        let eng1 = getEngagementOverTime(data).then((res) => ({ name: "eng1", data: res.data }));
        let data2 = { ...data };
        let durationGap = moment(data.end_date).diff(moment(data.start_date), "days", true);
        data2["start_date"] = moment(data.start_date)
            .subtract(durationGap + 1, "days")
            .startOf("day")
            .format("YYYY-MM-DD");
        data2["end_date"] = moment(data.start_date).subtract(1, "day").format("YYYY-MM-DD");

        let eng2 = getEngagementOverTime(data2).then((res) => ({ name: "eng2", data: res.data }));

        Promise.all([eng1, eng2])
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response,
                        durationGap,
                    },
                });
                return response.data;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const IgPostsLikeOvertime = (data) => {
    return (dispatch) => {
        const chartName = data["name"];
        const aggs_val = data.agreegate_interval;

        let interval;
        if (aggs_val) {
            if (aggs_val === "yearly") interval = "year";
            else if (aggs_val === "monthly") interval = "month";
            else if (aggs_val === "weekly") interval = "week";
            else interval = "day";
        }

        let params = new URLSearchParams();

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", "0");
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("post_type", "0");
        params.append("exclude_post_subtypes", "story");
        params.append("aggs-interval", interval);
        params.append("aggs", "likes_datewise_breakdown");
        params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
        params.append("custom_query", `handlers.value:"${data.handler}"`);

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response.data,
                    },
                });
                return response.data;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const IgPostsCommentOvertime = (data) => {
    return (dispatch) => {
        const chartName = data["name"];
        const aggs_val = data.agreegate_interval;

        let interval;
        if (aggs_val) {
            if (aggs_val === "yearly") interval = "year";
            else if (aggs_val === "monthly") interval = "month";
            else if (aggs_val === "weekly") interval = "week";
            else interval = "day";
        }

        let params = new URLSearchParams();

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", "0");
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("post_type", "0");
        params.append("exclude_post_subtypes", "story");
        params.append("aggs-interval", interval);
        params.append("aggs", "comments_datewise_breakdown");
        params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
        params.append("custom_query", `handlers.value:"${data.handler}"`);

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response.data,
                    },
                });
                return response.data;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const IgPostsImpressions = (data) => {
    return (dispatch) => {
        const chartName = data["name"];
        const aggs_val = data.agreegate_interval;

        let interval;
        if (aggs_val) {
            if (aggs_val === "yearly") interval = "year";
            else if (aggs_val === "monthly") interval = "month";
            else if (aggs_val === "weekly") interval = "week";
            else interval = "day";
        }

        let params = new URLSearchParams();

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", "0");
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("post_type", "0");
        params.append("exclude_post_subtypes", "story");
        params.append("aggs-interval", interval);
        params.append("aggs", "impressions_datewise_breakdown");
        params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
        params.append("custom_query", `handlers.value:"${data.handler}"`);

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response.data,
                    },
                });
                return response.data;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const IgStoryViewsAndExits = (data) => {
    return (dispatch) => {
        const chartName = data["name"];
        const aggs_val = data.agreegate_interval;

        let interval;
        if (aggs_val) {
            if (aggs_val === "yearly") interval = "year";
            else if (aggs_val === "monthly") interval = "month";
            else if (aggs_val === "weekly") interval = "week";
            else interval = "day";
        }

        let params = new URLSearchParams();

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", "0");
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("post_type", "0");
        params.append("post_subtype", "story");
        params.append("aggs-interval", interval);
        params.append("aggs", "view_datewise_breakdown,exits_datewise_breakdown");
        params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
        params.append("custom_query", `handlers.value:"${data.handler}"`);

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response.data,
                    },
                });
                return response.data;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const IgStoryReplies = (data) => {
    return (dispatch) => {
        const chartName = data["name"];
        const aggs_val = data.agreegate_interval;

        let interval;
        if (aggs_val) {
            if (aggs_val === "yearly") interval = "year";
            else if (aggs_val === "monthly") interval = "month";
            else if (aggs_val === "weekly") interval = "week";
            else interval = "day";
        }

        let params = new URLSearchParams();

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", "0");
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("post_type", "0");
        params.append("post_subtype", "story");
        params.append("aggs-interval", interval);
        params.append("aggs", "comments_datewise_breakdown");
        params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
        params.append("custom_query", `handlers.value:"${data.handler}"`);

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response.data,
                    },
                });
                return response.data;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const IgStoryTaps = (data) => {
    return (dispatch) => {
        const chartName = data["name"];
        const aggs_val = data.agreegate_interval;

        let interval;
        if (aggs_val) {
            if (aggs_val === "yearly") interval = "year";
            else if (aggs_val === "monthly") interval = "month";
            else if (aggs_val === "weekly") interval = "week";
            else interval = "day";
        }

        let params = new URLSearchParams();

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", "0");
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("post_type", "0");
        params.append("post_subtype", "story");
        params.append("aggs-interval", interval);
        params.append("aggs", "taps_forwards_datewise_breakdown,taps_backwards_datewise_breakdown");
        params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
        params.append("custom_query", `handlers.value:"${data.handler}"`);

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response.data,
                    },
                });
                return response.data;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const IgStoryReach = (data) => {
    return (dispatch) => {
        const chartName = data["name"];
        const aggs_val = data.agreegate_interval;

        let interval;
        if (aggs_val) {
            if (aggs_val === "yearly") interval = "year";
            else if (aggs_val === "monthly") interval = "month";
            else if (aggs_val === "weekly") interval = "week";
            else interval = "day";
        }

        let params = new URLSearchParams();

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", "0");
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("post_type", "0");
        params.append("post_subtype", "story");
        params.append("aggs-interval", interval);
        params.append("aggs", "view_datewise_breakdown");
        params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
        params.append("custom_query", `handlers.value:"${data.handler}"`);

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response.data,
                    },
                });
                return response.data;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const IgPostsImpressionsOvertime = (data) => {
    return (dispatch) => {
        const chartName = data["name"];
        const aggs_val = data.agreegate_interval;

        let interval;
        if (aggs_val) {
            if (aggs_val === "yearly") interval = "year";
            else if (aggs_val === "monthly") interval = "month";
            else if (aggs_val === "weekly") interval = "week";
            else interval = "day";
        }

        let params = new URLSearchParams();

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", "0");
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("post_type", "0");
        params.append("exclude_post_subtypes", "story");
        params.append("aggs-interval", interval);
        params.append("aggs", "impressions_datewise_breakdown");
        params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
        params.append("custom_query", `handlers.value:"${data.handler}"`);

        dispatch({
            type: "FETCH_IG_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_IG_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response.data,
                    },
                });
                return response.data;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_IG_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export function fetchPageFollowers(params) {
    let res = axios({
        method: "get",
        url: `https://graph.facebook.com/v12.0/${params.page_id}?fields=followers_count&access_token=${params.access_token}`,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err?.response?.data?.message);
            return err;
        });
    return {
        type: "FETCH_PAGE_FOLLOWERS",
        payload: res,
    };
}

export const fetchIgRecentPostsData = (dispatch, params, chartName) => {
    dispatch({
        type: "FETCH_IG_METRICS_PENDING",
        payload: { chart_name: chartName },
    });
    let res = axios
        .post(getUrl("searchaggs"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_IG_METRICS_FULFILLED",
                payload: { chart_name: chartName, response: response.data?.hits?.hits },
            });
        })
        .catch((error) => {
            console.log(error);
            dispatch({
                type: "FETCH_IG_METRICS_REJECTED",
                payload: { chart_name: chartName },
            });
        });
};
